import { Copy, MessageCircle, Mail, Send } from "lucide-react";
import { toast } from "sonner";

export default function ShareButtons({ url, title, text, previewUrl }) {
  const u = encodeURIComponent(url);
  const pu = encodeURIComponent(previewUrl || url);
  const t = encodeURIComponent(title || "Check this out on EarnMate");
  // Full message (title + date + venue + payment + description) falls back to title if not given
  const msg = encodeURIComponent(text || title || "Check this out on EarnMate");
  const copy = () => { navigator.clipboard.writeText(url); toast.success("Link copied"); };
  return (
    <div className="flex flex-wrap gap-2" data-testid="share-buttons">
      <a href={`https://wa.me/?text=${msg}%20${pu}`} target="_blank" rel="noreferrer" className="btn-tint px-3 py-2 text-xs" data-testid="share-whatsapp"><MessageCircle className="w-4 h-4" /> WhatsApp</a>
      <a href={`https://t.me/share/url?url=${pu}&text=${msg}`} target="_blank" rel="noreferrer" className="btn-tint px-3 py-2 text-xs" data-testid="share-telegram"><Send className="w-4 h-4" /> Telegram</a>
      <a href={`mailto:?subject=${t}&body=${msg}%0A%0A${u}`} className="btn-tint px-3 py-2 text-xs" data-testid="share-email"><Mail className="w-4 h-4" /> Email</a>
      <button onClick={copy} className="btn-tint px-3 py-2 text-xs" data-testid="share-copy"><Copy className="w-4 h-4" /> Copy link</button>
    </div>
  );
}
